import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import type { FormContactProps } from "../../types/form.types";
import type { FormikHelpers } from "formik";
import * as Yup from "yup";

const initialValues = {
  address: "",
  name: "",
  lastname: "",
  phone: "",
  department: "",
  city: "",
  email: "",
  contactReason: "",
  message: "",
  attachment: null,
};

export const useValidationForm = (
  onSubmit: (
    values: FormContactProps,
    formikHelpers: FormikHelpers<any>
  ) => void
) => {
  const { t } = useTranslation();
  const validationSchema = Yup.object({
    address: Yup.string()
      .required(t("field.required"))
      .max(60, t("field.address.max", { maxChars: 60 })),
    name: Yup.string()
      .required(t("field.required"))
      .matches(/^[a-zA-Z0-9\s]+$/, {
        message: t("field.documentNumber.invalid"),
      })
      .min(3, t("field.name.min", { minChars: 3 }))
      .max(20, t("field.name.max", { maxChars: 20 })),
    lastname: Yup.string()
      .required(t("field.required"))
      .matches(/^[a-zA-Z0-9\s]+$/, {
        message: t("field.documentNumber.invalid"),
      })
      .min(3, t("field.lastname.min", { minChars: 3 }))
      .max(20, t("field.lastname.max", { maxChars: 20 })),
    phone: Yup.string()
      .matches(/^\d{1,10}$/, {
        message: t("field.phone.invalid", { maxChars: 10 }),
      })
      .required(t("field.required")),
    department: Yup.string().required(t("field.required")),
    city: Yup.string().required(t("field.required")),
    email: Yup.string()
      .email(t("field.email.invalid"))
      .required(t("field.required"))
      .max(100, t("field.email.max", { maxChars: 100 })),
    contactReason: Yup.string().required(t("field.required")),
    message: Yup.string()
      .required(t("field.required"))
      .max(600, t("field.message.max", { maxChars: 600 })),
    attachment: Yup.mixed().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return {
    formik,
    validationSchema,
  };
};
